import axiosClient from './axiosClient';

export const updateSubscription = (deviceId) => {
    return axiosClient.post(`/webpushdevices/${deviceId}`);
}
